import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, AlertTriangle, Bell } from "lucide-react";

const SEV = {
  high: { bg: "border-l-destructive bg-destructive/5", c: "text-destructive" },
  medium: { bg: "border-l-primary bg-primary/5", c: "text-primary" },
  low: { bg: "border-l-muted-foreground bg-secondary/30", c: "text-muted-foreground" },
};

export default function Alerts() {
  const [alerts, setAlerts] = useState(null);
  useEffect(() => { api.get("/alerts").then((r) => setAlerts(r.data)).catch(() => {}); }, []);
  if (!alerts) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="max-w-3xl mx-auto space-y-3 animate-float-up" data-testid="alerts-panel">
      {alerts.map((a) => {
        const s = SEV[a.severity] || SEV.low;
        return (
          <div key={a.id} data-testid={`alert-${a.id}`} className={`border border-border border-l-2 rounded-2xl p-4 flex gap-4 ${s.bg}`}>
            <AlertTriangle className={`w-5 h-5 mt-0.5 shrink-0 ${s.c}`} />
            <div className="flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className={`text-[10px] font-mono uppercase tracking-widest ${s.c}`}>{a.type}</span>
                <span className="text-[11px] text-muted-foreground">{a.time}</span>
              </div>
              <p className="font-medium text-sm mt-1">{a.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{a.detail}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
